module.exports = __webpack_public_path__ + "img/banner11.e0a61f24.jpg";